export function dateStringToDate(dateString) {
  return new Date(dateString);
}